window.addEventListener('DOMContentLoaded', () => {
	const masonry = new Isotope('.block--galleries__galleries', {
		itemSelector: '.gallery-item',
		layoutMode: 'masonry',
		masonry: {
			columnWidth: '.gallery-sizer',
			gutter: 16,
		},
	});

	const filterFromHash = () => {
		const hash = window.location.hash.replace('#', '');
		let filterValue = hash;

		filterValue = hash ? `.${hash}` : '*';

		masonry.arrange({ filter: filterValue });
	};

	window.addEventListener('hashchange', filterFromHash);

	const buttons = document.querySelectorAll('.block--galleries__filters button');

	buttons.forEach((button) => {
		button.addEventListener('click', (event) => {
			const { target } = event;
			const { filter } = target.dataset;

			buttons.forEach((b) => {
				b.classList.remove('active');
			});

			target.classList.add('active');
			masonry.arrange({ filter });
		});
	});
});
